/* eslint-disable react/jsx-no-bind */
import * as React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import MetaTags from 'react-meta-tags';
import ShareService from '../../services/shareService.js';
import Loading from '../common/Loading.js';

class HowItWorks extends React.Component {
    constructor(props, context) {
        super(props, context);     
    }

    componentDidMount() {
        if(this.explainerContainer) {
            //convert player shut down, I tried copying the script to /public/convertPlayer.js and it didn't work
            $(this.explainerContainer).html('<script src="https://cpem.io/pV5SW5Fss.js?w=460&h=259" />');
        }
    }

    render() {
        const title = 'What is LoudUp?';
        const description = 'Introducing LoudUp - find out who we are and what we can do for you!';
        const url = ShareService.getAbsoluteUrl(this.props.match.url);
        const imageUrl = ShareService.getAbsoluteUrl(require('../../images/video-cover.jpg'));
        const videoUrl = "https://www.youtube.com/v/XXOMhkilkbI";
        return (
            <div className="main">
                <MetaTags>       
                    <title>How it works - LoudUp</title>     
                    <meta id="description" name="description" content="Explanation of what LoudUp is, definition of our site-specific terminology, and a list of our essential features." />   
                    <meta id="og-title" property="og:url" content={title} />
                    <meta id="og-url" property="og:url" content={url} />
                    <meta id="og-description" property="og:description" content={description} />
                    <meta name="twitter:card" content="player" />
                    <meta id="twitter-url" name="twitter:url" content={url} />
                    <meta id="twitter-title" name="twitter:title" content={title} />
                    <meta id="twitter-description" name="twitter:description" content={description} />
                    <meta name="twitter:image" content={imageUrl} />
                    <meta name="twitter:player" content={videoUrl} /> 
                    <meta name="twitter:player:width" content="480" />
                    <meta name="twitter:player:height" content="270" />
                    <meta id="og-type" property="og:type" content="video" />
                    <meta id="og-image" property="og:image" content={imageUrl} />
                    <meta property="og:video" content={videoUrl} />
                    <meta property="og:video:secure_url" content={videoUrl} />
                    <meta property="og:video:height" content="270" />
                    <meta property="og:video:width" content="480" />
                    <meta property="og:video:type" content="video/mp4" />
                    <meta property="video:duration" content="61" />
                </MetaTags>
                <div className="container">
                    <div className="block-inner">
                        <div className="row">
                            <div className="col-md-12">
                                <article className="body-copy">
                                    <header>
                                        <h1 className="section-alt">How it works</h1>
                                    </header>
                                    <div className="body-narrow">
                                        <ul className="list-unstyled list-how">
                                            <li>
                                                <img className="picto" src={require('../../images/picto-whatisloudup.png')} alt="What is LoudUp?"/>
                                                <h3>What is LoudUp?</h3>
                                                <p>LoudUp is a music-based social network designed to:</p>
                                                <ul className="list-unstyled">
                                                    <li>help music fans to connect, discover new music, and find gigs in their area</li>
                                                    <li>help independent artists to promote their music and connect with fans as well as other artists and industry professionals.</li>
                                                </ul>
                                                <br />
                                                <p>Watch the video below to find out more:</p>
                                                <div className="explainer" ref={(control) => this.explainerContainer = control}>
                                                    <Loading />
                                                </div>
                                            </li>
                                            <li>
                                                <img className="picto" src={require('../../images/picto-terminology.png')} alt="LoudUp Terminology"/>
                                                <h3>LoudUp Terminology</h3>
                                                <p>Turn me up, Plug In, LoudUp rating...here's the breakdown:</p>
                                                <ul className="list-unstyled">
                                                    <li>Every artist, producer, and musician on the site has a LoudUp rating which is a score in decibels (dB). We're all about loudness here so the louder an artist is, the more highly they have been rated. The 'turn me up' button that you will see around the site enables you to increase the loudness of a song or video, and that in turn increases the loudness of the artist.</li>
                                                    <li>Plugging into someone means that you will see their updates on your Notifications page. You will be notified for events such as if they add new songs and videos, announce a new gig, or if they turn up a song or video. You will be able to see who you are plugged into and who is plugged into you on your profile page.</li>
                                                </ul>
                                            </li>
                                            <li>
                                                <img className="picto" src={require('../../images/picto-features.png')} alt="Essential Features"/>
                                                <h3>Essential Features</h3>
                                                <ul className="list-unstyled">
                                                    <li><Link to="/Account/SignUp">Sign up</Link> and create a free profile</li>
                                                    <li>Click on the Explore > Artists link in the menu above to check out all of our artists. The icons and numbers next to the artist's names will show you how many songs and videos the artist has available on their profile. You will also see their LoudUp rating. Click on Filter to filter the artists shown by genre or location.</li>
                                                    <li>Click on the Explore > Fans link to check out all of our music fans. The icons and numbers next to the fan's names will show you how many songs and videos they have rated. Plug into fans who share your music taste, and you can discover new music through them! Any songs or videos that they 'turn up' will appear in your notications.</li>
                                                    <li>Click on Go to view all the upcoming gigs. You can filter by location to find the gigs in your area, and can also filter by genre or date. Click on the event name or details button to view the full details.</li>
                                                    <li>If you are an Artist, you can find essential services such as producers, musicians, labels, songwriters, venues, promoters, managers, and studios in the Explore menu. Also check out our <Link to="/RecommendedLinks">recommended links</Link> page to find external resources that we think you will find useful.</li>
                                                    <li>Click on the Chatter > Discussions link to join the conversations going on in the LoudUp community</li>
                                                </ul>
                                            </li>
                                            <li style={{paddingTop:"10px"}}>                                    
                                                <div>
                                                    <button onClick={() => this.props.history.push('/Account/Signup')} className="btn btn-primary btn-signup transition">SIGNUP</button>
                                                    <br />
                                                    <br />
                                                    <br />
                                                    Are you an unsigned artist or band looking to get your music heard? Find out more about <Link to="/PromoteYourMusic">how to promote your music</Link> including sections on how to get your music heard and how to increase your fanbase.
                                                    <br />
                                                    <br />
                                                    Got questions? Check out our <Link to="/FAQ">frequently asked questions</Link> page
                                                </div>
                                                <br />
                                            </li>
                                        </ul>
                                    </div>
                                </article>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

HowItWorks.propTypes = {
    match: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired
};

export default HowItWorks;